import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { CoreLink } from '@uncinc/react-drupal-core';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import addressMapsLink from '../../../../helpers/addressMapsLink';
import { TaxonomyLocation } from '../../../../types/uncinc_profile/taxonomy';

interface LocationEventProps {
  entity: ImmutableEntity<TaxonomyLocation>;
}

const TaxonomyLocationEvent: React.FC<LocationEventProps> = ({ entity }) => {
  const { t } = useTranslation();

  const term = entity.toJS();
  const name = term.name[0].value;
  const address = term.field_address[0];

  const url = addressMapsLink(address, name);

  return (
    <>
      <p className="mb-1 body--small">{name}</p>
      <p className="body--small">
        <CoreLink
          to={url}
          title={t('components.block_event_info.navigate')}
        />
      </p>
    </>
  );
};

export default TaxonomyLocationEvent;
